export default __webpack_public_path__ + "static/media/AppleLogo.e844d3fb.svg";